import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';

export const useAuth = () => {
  const {
    isAuthenticated,
    isLoading,
    user,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
    error,
  } = useAuth0();

  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      void getAccessTokenSilently()
        .then((token: string) => {
          setToken(token);
        })
        .catch(() => {
          setToken(null);
        });
    } else {
      setToken(null);
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  const login = () => {
    void loginWithRedirect();
  };

  const logoutUser = () => {
    void logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };
  const platformUser = user ? user['https://opengov.com/platform_user'] : '';
  const primaryEntity = user
    ? (user['https://opengov.com/primary_entity']?.subdomain ?? null)
    : null;

  return {
    isAuthenticated,
    isLoading,
    user,
    platformUser,
    primaryEntity,
    error,
    login,
    logout: logoutUser,
    getAccessTokenSilently,
    token,
  };
};
